<!--suppress JSUnfilteredForInLoop -->
<template>
    <div v-if="allowed.read" class="flex-root-row">
        <div class="flex-root-column editor-box">
            <!-- Header -->
            <div class="editor-table tags" ref="tagsTable">
                <table class="vcs-table">
                    <tr>
<!--                        <th class="vcs-table-header">#</th>-->
                        <th
                                v-for="header in columns"
                                :key="header.id"
                                v-show="visibleColumns[header.id] && (header.id !== 'actions' || allowed.write)"
                                class="vcs-table-header"
                                :class="(ownSortingColumn === header.id ? 'sorted' + (ownSortingDirection === 'asc' ? ' sorted-ascending' : ' sorted-descending' ) : '')"
                                :style="(header.width ? 'width: ' + header.width + 'px; min-width: ' + header.width + 'px;' : '')"
                                @click="changeSorting(header.id)"
                        >
                            <div class="vcs-table-header-title">{{$t(header.title)}}{{ header.required ? ' *' : '' }}</div>
                            <div
                                v-show="header.filter"
                                class="vcs-table-header-filter"
                                :class="{active: typeof activeFilterValues[header.id] !== 'undefined'}"
                                @click.stop="showFilter(header.id)"
                                :title="filterTitle(header.id)"
                            ></div>
                        </th>
                    </tr>
                    <tr
                            v-if="activeTagCount === 0"
                            class="no-data">
                        <td :colspan="columns.length">-- {{$t('no CEDEX configuration found')}} --<br /><div class="add-first-line" @click="addRow()">{{$t('add data')}}</div></td>
                    </tr>
                    <tr
                        v-for="(tag, tagIndex) in paginatedTagData"
                        :key="tag.id + '_' + tagIndex"
                        :class="{active: tag.active, inactive: !tag.active, selected: tagIndex === selectedRow}"
                        @click="selectCell(tagIndex)"
                    >
<!--                        <td>{{tagIndex}}</td>-->
                        <td
                                v-if="visibleColumns.name && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                :class="failedValidation[tagIndex + '_name'] ? 'validation-failed' : ''"
                        >
                            <div v-if="!allowed.write || selectedRow !== tagIndex">{{tag.name}}</div>
                            <v-text-field
                                    v-else
                                    :value="tag.name"
                                    @change="changeData(tagIndex, 'name', $event)"
                            >{{tag.name}}</v-text-field>
                        </td>

                        <td
                                v-if="visibleColumns.nameDe && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                        >
                            <div v-if="!allowed.write || selectedRow !== tagIndex">{{tag.nameDe}}</div>
                            <v-text-field
                                    v-else
                                    :value="tag.nameDe"
                                    @change="changeData(tagIndex, 'nameDe', $event)"
                            >{{tag.nameDe}}</v-text-field>
                        </td>

                        <td
                                v-if="visibleColumns.nameRu && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                        >
                            <div v-if="!allowed.write || selectedRow !== tagIndex">{{tag.nameRu}}</div>
                            <v-text-field
                                    v-else
                                    :value="tag.nameRu"
                                    @change="changeData(tagIndex, 'nameRu', $event)"
                            >{{tag.nameRu}}</v-text-field>
                        </td>

                        <td
                                v-if="visibleColumns.internal && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                class="center"
                        >
                            <v-checkbox
                                    dense
                                    color="#355b7f"
                                    v-model="tag.internal"
                                    :disabled="!allowed.write || selectedRow !== tagIndex"
                                    @change="changeData(tagIndex, 'internal', $event)"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.decisionRequired && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                class="center"
                        >
                            <v-checkbox
                                    dense
                                    color="#355b7f"
                                    v-model="tag.decisionRequired"
                                    :disabled="!allowed.write || selectedRow !== tagIndex"
                                    @change="changeData(tagIndex, 'decisionRequired', $event)"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.priceRelevant && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                class="center"
                        >
                            <v-checkbox
                                    dense
                                    color="#355b7f"
                                    v-model="tag.priceRelevant"
                                    :disabled="!allowed.write || selectedRow !== tagIndex"
                                    @change="changeData(tagIndex, 'priceRelevant', $event)"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.active && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                class="center"
                        >
                            <v-checkbox
                                    dense
                                    color="#355b7f"
                                    v-model="tag.active"
                                    :disabled="!allowed.write || selectedRow !== tagIndex"
                                    @change="changeData(tagIndex, 'active', $event)"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.files && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                        >
                            <files
                                :key="tagIndex + '_files_' + tag.files.length"
                                :files="tag.files"
                                @removeFile="removeFile(tag.tagId, $event)"
                                @addFile="addFile(tag.tagId, $event)"
                                @showMessage="showMessage"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.tagType && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                :class="failedValidation[tagIndex + '_tagType'] ? 'validation-failed' : ''"
                        >
                            <div v-if="!allowed.write || selectedRow !== tagIndex"
                                >{{tagTypes[tag.tagType] || $t('-- please select --')}}</div>
                            <v-select
                                    v-else
                                    v-model="tag.tagType"
                                    :items="tagTypesArray"
                                    item-value="id"
                                    item-text="name"
                                    @change="changeData(tagIndex, 'tagType', $event)"
                            />
                        </td>

                        <td
                                v-if="visibleColumns.tagDisplay && tag.rowSpan_tagDisplay"
                                :rowSpan="tag.rowSpan_tagDisplay"
                                :class="failedValidation[tagIndex + '_tagDisplay'] ? 'validation-failed' : ''"
                        >
                            <div v-if="!allowed.write || selectedRow !== tagIndex"
                                >{{tagTypes[tag.tagDisplay] || $t('-- please select --')}}</div>
                            <v-select
                                    v-else
                                    v-model="tag.tagDisplay"
                                    :items="getAvailableTagTypes(tagIndex, 'tagDisplay')"
                                    item-value="id"
                                    item-text="name"
                                    @change="changeData(tagIndex, 'tagDisplay', $event)"
                            />
                        </td>

                        <TagsGroupedSelectTableCell
                                v-if="tag.rowSpan_serviceType && visibleColumns.serviceType"
                                :readonly="!allowed.write"
                                type="serviceType"
                                :value="tag.serviceType"
                                :all-values-object="serviceTypes"
                                :ref="'tagColumn_serviceType_' + tagIndex"
                                :all-values-array="parseCodeDependencyData(tagIndex, 'serviceType')"
                                :rowSpan="tag.rowSpan_serviceType"
                                :show-add-row="tag.showPlus_serviceType"
                                :code-texts="'label'"
                                :css-class="failedValidation[tagIndex + '_serviceType'] ? 'validation-failed' : ''"

                                @changeSelection="changeSelection($event, tagIndex, 'serviceType')"
                                @addRow="addRow(tagIndex, 'serviceType')"
                        />

                        <TagsGroupedSelectTableCell
                                v-if="tag.rowSpan_isoCode && visibleColumns.isoCode"
                                :readonly="!allowed.write"
                                type="isoCode"
                                :value="tag.isoCode"
                                :all-values-object="isoCodes"
                                :ref="'tagColumn_isoCode_' + tagIndex"
                                :all-values-array="groupCodes('isoCode', isoCodesArray)"
                                :rowSpan="tag.rowSpan_isoCode"
                                :show-add-row="tag.showPlus_isoCode"
                                :code-texts="codeTexts"
                                :group-values-map="isoCodeToSurveyTypeName"
                                :css-class="failedValidation[tagIndex + '_isoCode'] ? 'validation-failed' : ''"

                                @changeSelection="changeSelection($event, tagIndex, 'isoCode')"
                                @addRow="addRow(tagIndex, 'isoCode')"
                        />

                        <TagsGroupedSelectTableCell
                                v-if="tag.rowSpan_locationCode && visibleColumns.locationCode"
                                :readonly="!allowed.write"
                                type="locationCode"
                                :value="tag.locationCode"
                                :all-values-object="locationCodes"
                                :ref="'tagColumn_locationCode_' + tagIndex"
                                :all-values-array="groupCodes('locationCode', locationCodesArray)"
                                :rowSpan="tag.rowSpan_locationCode"
                                :show-add-row="tag.showPlus_locationCode"
                                :code-texts="codeTexts"
                                :group-values-map="locationCodePrefixToViewTypeName"
                                :css-class="failedValidation[tagIndex + '_locationCode'] ? 'validation-failed' : ''"
                                :initial-edit-mode="allowed.write"
                                :display-short-all-values="true"

                                @changeSelection="changeSelection($event, tagIndex, 'locationCode')"
                                @addRow="addRow(tagIndex, 'locationCode')"
                        />

                        <TagsSelectTableCell
                                v-if="tag.rowSpan_componentCode && visibleColumns.componentCode"
                                :readonly="!allowed.write"
                                type="componentCode"
                                :value="tag.componentCode"
                                :all-values-object="componentCodes"
                                :ref="'tagColumn_componentCode_' + tagIndex"
                                :all-values-array="componentCodesArray"
                                :code-texts="codeTexts"
                                :rowSpan="tag.rowSpan_componentCode"
                                :show-add-row="tag.showPlus_componentCode"
                                :css-class="failedValidation[tagIndex + '_componentCode'] ? 'validation-failed' : ''"
                                :add-empty-option="true"
                                empty-option-text="-- please select --"

                                @changeSelection="changeSelection($event, tagIndex, 'componentCode')"
                                @addRow="addRow(tagIndex, 'componentCode')"
                        />

                        <TagsSelectTableCell
                                v-if="tag.rowSpan_damageCode && visibleColumns.damageCode"
                                :readonly="!allowed.write"
                                :visible="!(tag.tagType === 'component' && tag.tagDisplay === 'component')"
                                type="damageCode"
                                :value="tag.damageCode"
                                :key="tagIndex + '_damage_' + tag.damageCode"
                                :all-values-object="damageCodes"
                                :all-values-array="damageCodesArray"
                                :ref="'tagColumn_damageCode_' + tagIndex"
                                :code-texts="codeTexts"
                                :rowSpan="tag.rowSpan_damageCode"
                                :show-add-row="tag.showPlus_damageCode"
                                :css-class="failedValidation[tagIndex + '_damageCode'] ? 'validation-failed' : ''"
                                :add-empty-option="true"
                                empty-option-text="-- please select --"

                                @changeSelection="changeSelection($event, tagIndex, 'damageCode')"
                                @addRow="addRow(tagIndex, 'damageCode')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.repairCode"
                                :readonly="!allowed.write"
                                :visible="(tag.tagType === 'repair' || tag.tagDisplay === 'repair')"
                                type="repairCode"
                                :value="tag.repairCode"
                                :key="tagIndex + '_repair_' + tag.repairCode"
                                :all-values-object="repairCodes"
                                :all-values-array="repairCodesArray"
                                :ref="'tagColumn_repairCode_' + tagIndex"
                                :code-texts="codeTexts"
                                :show-add-row="tag.showPlus_repairCode"
                                :css-class="failedValidation[tagIndex + '_repairCode'] ? 'validation-failed' : ''"
                                :add-empty-option="true"
                                empty-option-text="-- please select --"

                                @changeSelection="changeSelection($event, tagIndex, 'repairCode')"
                                @addRow="addRow(tagIndex, 'repairCode')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.inspectionCriteria"
                                :readonly="!allowed.write"
                                type="inspectionCriteria"
                                :value="tag.inspectionCriteria"
                                :all-values-object="inspectionCriterias"
                                :all-values-array="inspectionCriteriasArray"
                                :ref="'tagColumn_inspectionCriteria_' + tagIndex"
                                :code-texts="false"
                                :multi-select="isMultiSelectColumn('inspectionCriteria')"
                                :css-class="failedValidation[tagIndex + '_inspectionCriteria'] ? 'validation-failed' : ''"

                                @changeSelection="changeSelection($event, tagIndex, 'inspectionCriteria')"
                                @addRow="addRow(tagIndex, 'inspectionCriteria')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.leasingCompany"
                                :readonly="!allowed.write"
                                type="leasingCompany"
                                :value="tag.leasingCompany"
                                :all-values-object="leasingCompanys"
                                :all-values-array="leasingCompanysArray"
                                code-texts="label"
                                :multi-select="isMultiSelectColumn('leasingCompany')"
                                :display-short-all-values="true"

                                @changeSelection="changeSelection($event, tagIndex, 'leasingCompany')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.shippingLine"
                                :readonly="!allowed.write"
                                type="shippingLine"
                                :value="tag.shippingLine"
                                :all-values-object="shippingLines"
                                :all-values-array="shippingLinesArray"
                                code-texts="label"
                                :multi-select="isMultiSelectColumn('shippingLine')"
                                :display-short-all-values="true"

                                @changeSelection="changeSelection($event, tagIndex, 'shippingLine')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.carcassManufacturer"
                                :readonly="!allowed.write"
                                type="carcassManufacturer"
                                :value="tag.carcassManufacturer"
                                :all-values-object="carcassManufacturers"
                                :all-values-array="carcassManufacturersArray"
                                code-texts="label"
                                :add-empty-option="true"
                                empty-option-text="-- all values --"
                                empty-text="-- all values --"

                                @changeSelection="changeSelection($event, tagIndex, 'carcassManufacturer')"
                        />

                        <TagsSelectTableCell
                                v-if="visibleColumns.machineryManufacturer"
                                :readonly="!allowed.write"
                                type="machineryManufacturer"
                                :value="tag.machineryManufacturer"
                                :all-values-object="machineryManufacturers"
                                :all-values-array="machineryManufacturersArray"
                                code-texts="label"
                                :add-empty-option="true"
                                empty-option-text="-- all values --"

                                @changeSelection="changeSelection($event, tagIndex, 'machineryManufacturer')"
                        />

                        <ModelNumberRangeCell
                            v-if="visibleColumns.modelNumberRange"
                            :key="tagIndex + '_' + tag.modelNumberRange"
                            :readonly="!allowed.write"
                            :value="tag.modelNumberRange"
                            :pattern="modelNumberPatterns[tag.machineryManufacturer] || ''"
                            @changeSelection="changeSelection($event, tagIndex, 'modelNumberRange')"
                        />

                        <td
                                v-if="allowed.write && visibleColumns.actions"
                                class="actions"
                        ><img class="small delete" :class="{disabled: (tag.rowSpan_tagDisplay === 1 && tag.deleteable && !tag.added)}" src="@/assets/icons/table/bin.svg" @click="removeRow(tagIndex)" :key="'bin' + tagIndex" alt=""></td>
                    </tr>
                </table>
            </div>
            <v-pagination
                v-if="pageCount > 1"
                :length="pageCount"
                :total-visible="paginationVisibleButtons"
                v-model="currentPage"
                @input="setScrollTop"
            />
        </div>

        <TableFilters
            :key="equipment"
            ref="tagFilters"
            :filters="filters"
            @change="onFiltersChange"
        />
    </div>
</template>

<script>
    import TagsSelectTableCell from "./TagsSelectTableCell";
    import Files from "./Files";
    import i18n from '../../i18n';
    import TagsGroupedSelectTableCell from "./TagsGroupedSelectTableCell";
    import Vue from "vue";
    import authorization from "../../plugins/authorization";
    import TableFilters from "../Table/Filter/TableFilters.vue";
    import ModelNumberRangeCell from "./ModelNumberRangeCell.vue";
    import {popupShowTime} from "../../plugins/constants";

    export default {
        name: "CedexTags",
        components: {ModelNumberRangeCell, TableFilters, Files, TagsGroupedSelectTableCell, TagsSelectTableCell},
        props: {
            // view data selection
            codeTexts:    Boolean,
            equipment:    String,
            showInactive: Boolean,
            columns:      Array, // numeric index array with all columnData (0 => {id, title, visible, width, filter, required})
            isoCodeToSurveyTypeName: Object,
            locationCodePrefixToViewTypeName:  Object,

            // tag data
            tags:                   Object,
            dependencies:           Object,
            selectableDependencies: Object,
            sortingColumn:    {
                type:    String,
                default: null
            },
            sortingDirection: {
                type:    String,
                default: null
            },

            // codes and types
            tagTypes:               Object,
            serviceTypesArray:      Array,
            locationCodes:          Object,
            componentCodes:         Object,
            isoCodes:               Object,
            damageCodes:            Object,
            repairCodes:            Object,
            inspectionCriterias:    Object,
            leasingCompanys:        Object,
            shippingLines:          Object,
            carcassManufacturers:   Object,
            machineryManufacturers: Object,
            modelNumberPatterns:    Object,
        },
        data: function() {
            return {
                tagData: [],
                // Pagination
                paginationVisibleButtons: 7,
                currentPage: 1,
                pageSize:    50,
                // Sorting
                ownSortingColumn:    this.sortingColumn,
                ownSortingDirection: this.sortingDirection,

                removedTags: [],
                failedValidation: {},
                selectedRow:    null, // table row index of selection
                selectedColumn: null, // column to selection

                dependencyOrder: [
                    'equipment',
                    'isoCode',
                    'locationCode',
                    'componentCode',
                    'damageCode',
                    'repairCode',
                    // 'inspectionCriteria', // always allow all inspection criteria // https://survey-compass.atlassian.net/browse/CORE-2304
                ],
                triggerDependencyUpdateColumns: [
                    'isoCode',
                    'locationCode',
                    'componentCode',
                    'damageCode',
                    'repairCode'
                ],
                // new cache for lazy loading dependencies on use
                codeDependencyCache: {},
                groupCodesCache:     {},
                activeFilterValues:  {},
                filterTypes: {
                    string: ['name', 'nameDe', 'nameRu'],
                    boolean: ['internal', 'decisionRequired', 'priceRelevant', 'active'],
                    data: [
                        'tagType', 'tagDisplay', 'serviceType', 'isoCode', 'locationCode', 'componentCode','damageCode',
                        'repairCode', 'inspectionCriteria', 'leasingCompany', 'shippingLine', 'carcassManufacturer',
                        'machineryManufacturer'
                    ]
                },

                columnsByEquipment: {
                    carcass: ['isoCode', 'carcassManufacturer'],
                    machinery: ['machineryManufacturer', 'modelNumberRange'],

                },

                allowed: {
                    read:  authorization.isAllowed('Settings/DPT Mobile/View'),
                    write: authorization.isAllowed('Settings/DPT Mobile/View', authorization.write),
                },
            }
        },
        watch: {
            equipment: function() {
                this.updateVisibleColumnsByEquipment(this.equipment);
            },
            tags: function() {
                this.calculateTagData();
                this.selectCell(null);
            },
            sortingColumn: function() {
                this.ownSortingColumn = this.sortingColumn;
            },
            sortingDirection: function() {
                this.ownSortingDirection = this.sortingDirection;
            }
        },
        mounted() {
            this.updateView('equipment', this.equipment);
            this.updateVisibleColumnsByEquipment(this.equipment);
        },
        methods: {
            setScrollTop()
            {
                this.$refs.tagsTable.scrollTo(0, 0)
            },

            scrollToLine(tagIndex, markupLine)
            {
                tagIndex -= this.paginationOffset;
                let line = this.$el.querySelector('div.editor-table table tr:nth-child(' + (tagIndex + 1) + ')');
                line.scrollIntoView({
                    block:    'end',
                    behavior: 'smooth'
                });

                if (markupLine) {
                    line.classList.add('newLine');
                }
            },

            updateView(name, value)
            {
                this.$emit('updateView', name, value, 'tags');
            },

            updateVisibleColumnsByEquipment(equipment)
            {
                for (let index in this.columns) {
                    if (this.columnsByEquipment.carcass.includes(this.columns[index].id)) {
                        this.columns[index].visible = equipment !== 'machinery'
                    }
                    if (this.columnsByEquipment.machinery.includes(this.columns[index].id)) {
                        this.columns[index].visible = equipment === 'machinery'
                    }
                }
            },

            changeSorting(column)
            {
                // every tree column is sorted ascending by default
                // so change sorting of one of these columns is only possible to descending
                // revert the descending sorting means the column is sorted ascending again
                // all columns after inspection criteria can be sorted ascending or
                if (this.ownSortingColumn === column) {
                    if (this.ownSortingDirection === 'desc') {
                        this.ownSortingDirection = 'asc';
                    } else {
                        this.ownSortingDirection = 'desc';
                    }
                } else {
                    this.ownSortingDirection = 'desc';
                }

                this.ownSortingColumn = column;

                this.$emit('updateView', 'sortingColumn', this.ownSortingColumn, this.ownSortingDirection);
            },

            showFilter(id)
            {
                this.$refs.tagFilters.activeFilter = id;
            },

            filterTitle(columnId)
            {
                // check available filters
                if (typeof this.activeFilterValues[columnId] === "undefined") {
                    return '';
                }

                let filterData = false;
                this.filters.forEach(iteratingFilter => {
                    if (iteratingFilter.name === columnId) {
                        filterData = iteratingFilter.data;
                    }
                });
                if (filterData === false) {
                    return '';
                }
                // extract filter names
                let texts = [];
                let activeColumnFilters = this.activeFilterValues[columnId]

                if (Array.isArray(activeColumnFilters)) {
                    filterData.forEach(filter => {
                        if (activeColumnFilters.includes(filter.id)) {
                            texts.push(filter.name);
                        }
                    });
                } else {
                    if (activeColumnFilters === true) {
                        texts.push(i18n.t('active'));
                    } else if (activeColumnFilters === false) {
                        texts.push(i18n.t('inactive'));
                    } else {
                        texts.push(i18n.t('contains {string}', {
                            string: activeColumnFilters,
                        }));
                    }
                }
                // join names with max 10 results and a '+ x more' option
                let output;
                if (texts.length > 10) {
                    output = texts.slice(0, 10).join('\r\n') + '\r\n+ ' + (texts.length - 10) + ' ' + i18n.t('more');
                } else {
                    output = texts.join('\r\n');
                }
                return output;
            },

            onFiltersChange(filterData, showResultGroup)
            {
                let activeFilters = {};
                Object.keys(filterData).forEach(name => {
                    let values = filterData[name];
                    if (
                        (
                            (
                                this.filterTypes.string.includes(name)
                                || this.filterTypes.data.includes(name)
                            )
                            && values.length
                        ) || (
                            this.filterTypes.boolean.includes(name)
                            && values !== null
                            && values !== 0
                        )
                    ) {
                        activeFilters[name] = values;
                    }
                });

                if (JSON.stringify(this.activeFilterValues) === JSON.stringify(activeFilters)) {
                    return false;
                }

                Object.assign(this.activeFilterValues, activeFilters);
                this.$emit('filterData', activeFilters, showResultGroup);
            },

            getRowSpanData(tagIndexWithPaginationOffset, column)
            {
                let currentIndex = tagIndexWithPaginationOffset;
                let rowSpan = 1;
                while(currentIndex >= 0) {
                    if (typeof this.tagData[currentIndex]['rowSpan_' + column] !== 'undefined') {
                        rowSpan = this.tagData[currentIndex]['rowSpan_' + column];
                        break;
                    }
                    currentIndex--;
                }

                return {
                    rowSpan: rowSpan,
                    index:   currentIndex
                }
            },

            isMultiSelectColumn(column)
            {
                return this.multiSelectColumns.includes(column);
            },

            isBooleanColumn(column)
            {
                return this.booleanColumns.includes(column);
            },

            getComponent(tagIndex, column)
            {
                let vueComponent = this.$refs['tagColumn_' + column + '_' + tagIndex];
                if (!vueComponent) {
                    return null;
                }
                return vueComponent[0];
            },

            changeSelection(selectValue, tagIndex, column)
            {
                if (!this.allowed.write) {
                    return;
                }

                tagIndex += this.paginationOffset;

                // handles the change of a (multi) select column
                let value;
                if (this.isMultiSelectColumn(column)) {
                    if (selectValue === null) {
                        value = null;
                    } else if (selectValue === '') {
                        value = '';
                    } else {
                        selectValue = selectValue.filter(function (el) {return el !== '';});
                        // get values or null for all values
                        if (selectValue.length === this[column + 'sArray'].length) {
                            value = null;
                        } else {
                            // remove empty values
                            value = selectValue.join(',');
                        }
                    }
                } else {
                    value = selectValue;
                }

                // change the tag data for all sub rows
                let rowSpanData = {
                    rowSpan: 1,
                    index:   tagIndex
                };
                if (this.columnOrder.indexOf(column) < this.columnOrder.indexOf('repairCode')) {
                    rowSpanData = this.getRowSpanData(tagIndex, column);
                }
                let changedRows = [];
                for (let i = rowSpanData.index; i < rowSpanData.index + rowSpanData.rowSpan; i++) {
                    let row = this.tagData[i];
                    row[column] = value;
                    Vue.set(this.tagData, i, row);

                    if (this.triggerDependencyUpdateColumns.includes(column)) {
                        changedRows.push(i);
                    }
                }

                this.setChanged();
                this.scrollToLine(tagIndex);

                /* deactivated dependencies
                // dependency update
                // recalculate all dependencies from the current column to the "right"
                // i.e. change component code -> update damage code, repair code and inspection criteria
                let currentColumnIndex = this.dependencyOrder.indexOf(column);
                for (
                    let updateColumnIndex = currentColumnIndex + 1;
                    updateColumnIndex < Object.keys(this.dependencyOrder).length;
                    updateColumnIndex++
                ) {
                    let updateColumn = this.dependencyOrder[updateColumnIndex];
                    if (
                        typeof updateColumn === 'undefined'
                        // interrupt at machineryManufacturer since it has no dependencies
                        // and controller type is only depending on from machinery manufacturer
                        || updateColumn === 'machineryManufacturer'
                    ) {
                        return;
                    }

                    for (
                        let updateRowIndex = rowSpanData.index;
                        updateRowIndex < rowSpanData.index + rowSpanData.rowSpan;
                        updateRowIndex++
                    ) {
                        this.updateDependencies(updateRowIndex, updateColumn)
                    }
                }*/
            },

            convertCodes(column, codeInName, filter = false)
            {
                let array = [];
                for (let code in this[column + 's']) {

                    // exclude values which are not in filter
                    if (
                        Array.isArray(filter)
                        && !filter.includes(code)
                    ) {
                        continue;
                    }

                    let element = {
                        id: code
                    };
                    if (this.codeTexts) {
                        element.name = (codeInName ? code + ' - ' : '') + this[column + 's'][code];
                    } else {
                        element.name = (codeInName ? code : this[column + 's'][code]);
                    }

                    array.push(element);
                }

                return array;
            },

            async removeRow(tagIndex)
            {
                if (!this.allowed.write) {
                    return;
                }

                // pagination correction
                tagIndex += this.paginationOffset;

                // check deletion type
                // if there is only one empty dependency, remove the tag completely

                let rowSpanData = this.getRowSpanData(tagIndex, 'tagDisplay');
                let deletionType;
                if (rowSpanData.rowSpan > 1) {
                    // more than one dependency
                    if (rowSpanData.index !== tagIndex) {
                        deletionType = 'removeRow';
                    } else {
                        deletionType = 'moveUp';
                    }
                } else {
                    // last dependency line
                    deletionType = 'removeTag';
                }

                let title, text;
                if (deletionType === 'removeTag') {
                    if (
                        this.tagData[tagIndex].rowSpan_tagDisplay === 1
                        && this.tagData[tagIndex].deleteable
                        && !this.tagData[tagIndex].added
                    ) {
                        return;
                    }

                    title = i18n.t('Delete CEDEX Tag');
                    text  = i18n.t('Do you really want to remove this tag line?');
                } else {
                    title = i18n.t('Delete CEDEX Tag Dependency');
                    text  = i18n.t('Do you really want to remove this tag dependency line?');
                }

                const res = await this.$dialog.confirm({
                    text: text,
                    title: title,
                    persistent: true,
                    actions: {
                        false: i18n.t('No'),
                        true:  i18n.t('Yes'),
                    },
                });

                if (!res) {
                    return;
                }


                // remove dependency from tag
                // if tag has more than one dependency
                // -> then search dependency and remove it (remove first line need special treatment)
                // -> else clear last dependency, so that at least one is available for the tag to display
                let removeIndex = null;
                // more than one dependency
                if (deletionType === 'removeRow') {
                    // clear row
                    removeIndex = tagIndex;
                } else if (deletionType === 'moveUp') {
                    // is parent row, move data
                    // move dependency data from line below to line above
                    let copyData = this.tagData[tagIndex + 1];
                    this.tagData[tagIndex].id                    = copyData.id;
                    this.tagData[tagIndex].serviceType           = copyData.serviceType;
                    this.tagData[tagIndex].isoCode               = copyData.isoCode;
                    this.tagData[tagIndex].locationCode          = copyData.locationCode;
                    this.tagData[tagIndex].componentCode         = copyData.componentCode;
                    this.tagData[tagIndex].damageCode            = copyData.damageCode;
                    this.tagData[tagIndex].repairCode            = copyData.repairCode;
                    this.tagData[tagIndex].inspectionCriteria    = copyData.inspectionCriteria;
                    this.tagData[tagIndex].leasingCompany        = copyData.leasingCompany;
                    this.tagData[tagIndex].shippingLine          = copyData.shippingLine;
                    this.tagData[tagIndex].carcassManufacturer   = copyData.carcassManufacturer;
                    this.tagData[tagIndex].machineryManufacturer = copyData.machineryManufacturer;
                    this.tagData[tagIndex].modelNumberRange        = copyData.modelNumberRange;
                    // remove line below
                    removeIndex = tagIndex + 1;

                } else if (deletionType === 'removeTag') {

                    // remove complete tag
                    // go through every line and look for the tag id in the tag id array
                    // if found, remove the array elements
                    // if it is the only tag, remove the complete line(s)
                    // add tag id in removed ids array
                    let removeRowIndexes = [];

                    let removeTagId = this.tagData[tagIndex].tagId;
                    this.removedTags.push(removeTagId);

                    // remove complete row
                    removeRowIndexes.push({
                        index: tagIndex,
                        count: this.tagData[tagIndex].rowSpan_tagDisplay
                    });

                    this.tagData.splice(
                        tagIndex, // tag index in tagData array
                        this.tagData[tagIndex].rowSpan_tagDisplay // row count = rowSpan of tagDisplay
                    );
                    this.fixCachedDependencies(tagIndex, 'remove');

                    this.selectCell(null); // reset selection

                    return; // no further correction is necessary
                }

                // correct row span and row plus

                // first collect the data for correcting the row span (to keep the tree structure intact)
                // the remove the data and correct the row spans

                // find the initial row index for row span correction
                // iterate from damage code to tag display until one of these columns have a row span > 1
                // every other columns will be ignored
                let initialRowSpanData;
                let correctLineIndex = removeIndex;
                let correctColumnIndex;
                let columnIndexTagDisplay = this.columnOrder.indexOf('tagDisplay');
                for (let columnIndex = this.columnOrder.indexOf('damageCode'); columnIndex >= columnIndexTagDisplay; columnIndex--) {
                    let columnName = this.columnOrder[columnIndex];
                    initialRowSpanData = this.getRowSpanData(removeIndex, columnName);
                    if (initialRowSpanData.rowSpan > 1) {
                        correctLineIndex = initialRowSpanData.index;
                        correctColumnIndex = columnIndex;
                        break;
                    }
                }

                // get the column row spans and row span indexes, which have to be corrected
                let rowSpans = {};
                for (let columnIndex = correctColumnIndex; columnIndex >= columnIndexTagDisplay; columnIndex--) {
                    let columnName = this.columnOrder[columnIndex];
                    rowSpans[columnName] = this.getRowSpanData(correctLineIndex, columnName);
                }

                if (removeIndex > 0) {
                    for (let columnIndex = this.columnOrder.indexOf('repairCode'); columnIndex >= columnIndexTagDisplay; columnIndex--) {
                        let columnName = this.columnOrder[columnIndex];
                        if (this.tagData[removeIndex]['showPlus_' + columnName]) {
                            this.tagData[removeIndex - 1]['showPlus_' + columnName] = true;
                        }
                    }
                }

                // remove the data
                this.tagData.splice(removeIndex, 1);
                this.fixCachedDependencies(tagIndex, 'remove');

                this.selectCell(null); // reset selection

                // fix the row span for the remaining columns:
                // columns with row span 1 can be ignored (they will be removed completely)
                // columns with row span > 1 have to be reduced by one
                for (let columnName in rowSpans) {
                    this.tagData[rowSpans[columnName].index]['rowSpan_' + columnName] = rowSpans[columnName].rowSpan - 1 || 1;
                }

                this.setChanged();
            },

            addRow(tagIndex, column)
            {
                if (!this.allowed.write) {
                    return;
                }

                if (typeof column === 'undefined') {
                    column = 'name';
                }
                if (typeof tagIndex === 'undefined') {
                    tagIndex = 0;
                } else {
                    tagIndex += this.paginationOffset;
                }

                // check for already added rows with empty fields
                // copy line data
                let line = {};
                let insertIndex = 0;
                if (
                    this.activeTagCount === 0
                    || column === 'name'
                ) {
                    line = {
                        tagId:                  Date.now() - 1,
                        name:                   i18n.t('New Tag'),
                        nameDe:                 '',
                        nameRu:                 '',
                        internal:               false,
                        decisionRequired:       false,
                        priceRelevant:          false,
                        active:                 true,
                        files:                  [],
                        tagType:                '',
                        tagDisplay:             '',
                        serviceType:            '',
                        isoCode:                this.equipment === 'machinery' ? null : '',
                        locationCode:           '',
                        componentCode:          '',
                        damageCode:             '',
                        repairCode:             '',
                        inspectionCriteria:     '',
                        leasingCompany:         '',
                        shippingLine:           '',
                        carcassManufacturer:    '',
                        machineryManufacturer:  '',
                        modelNumberRange:       '',
                        deleteable:             1,
                        rowSpan_tagDisplay:     1,
                        rowSpan_serviceType:    1,
                        rowSpan_isoCode:        1,
                        rowSpan_locationCode:   1,
                        rowSpan_componentCode:  1,
                        rowSpan_damageCode:     1,
                        showPlus_serviceType:   true,
                        showPlus_isoCode:       true,
                        showPlus_componentCode: true,
                        showPlus_damageCode:    true,
                        showPlus_repairCode:    true,
                        added:                  true
                    };

                    if (column === 'name') {
                        insertIndex = this.paginationOffset;
                    }
                } else {
                    Object.assign(line, this.tagData[tagIndex]);

                    // fix row span data (increase row span for inserting one row)
                    // iterate through columns from left to right and increase every affected span by one
                    // remove row span (aka set to 1) for every column from row type
                    let rowSpanData = this.getRowSpanData(tagIndex, 'isoCode');
                    for (let columnIndex = this.columnOrder.indexOf('tagDisplay'); columnIndex < this.columnOrder.length; columnIndex++) {
                        let columnName = this.columnOrder[columnIndex];

                        if (columnIndex < this.columnOrder.indexOf(column)) {
                            rowSpanData = this.getRowSpanData(tagIndex, columnName);
                            this.tagData[rowSpanData.index]['rowSpan_' + columnName] = rowSpanData.rowSpan + 1;
                            delete line['rowSpan_' + columnName];
                        } else {
                            if (columnIndex <= this.columnOrder.indexOf('damageCode')) {
                                line['rowSpan_' + columnName] = 1;
                            }
                            line[columnName] = (['serviceType', 'isoCode', 'locationCode'].indexOf(columnName) >= 0) ? '' : null;
                        }
                    }

                    // clear values for
                    line.inspectionCriteria    = '';
                    line.leasingCompany        = null;
                    line.shippingLine          = null;
                    line.carcassManufacturer   = null;
                    line.machineryManufacturer = null;
                    line.modelNumberRange      = null;

                    // add new line at specific position
                    insertIndex = rowSpanData.index + rowSpanData.rowSpan;
                }

                line.id = Date.now();
                // add line to data, correct insert index with pagination data
                this.tagData.splice(insertIndex, 0, line);

                // fix dependency cache
                this.fixCachedDependencies(insertIndex, 'add');

                // scroll into view and mark new line
                this.$nextTick(() => this.scrollToLine(insertIndex, true));

                this.setChanged();
            },

            getCodeDependencies(tagIndex, column)
            {
                tagIndex += this.paginationOffset;
                if (
                    this.codeDependencyCache[this.equipment]
                    && this.codeDependencyCache[this.equipment][column]
                    && this.codeDependencyCache[this.equipment][column][tagIndex]
                ) {
                    return this.codeDependencyCache[this.equipment][column][tagIndex];
                }

                return null;
            },

            setCodeDependencies(tagIndex, column, values)
            {
                tagIndex += this.paginationOffset;
                if (typeof this.codeDependencyCache[this.equipment] === 'undefined') {
                    this.codeDependencyCache[this.equipment] = {}
                }
                if (typeof this.codeDependencyCache[this.equipment][column] === 'undefined') {
                    this.codeDependencyCache[this.equipment][column] = {}
                }
                if (typeof this.codeDependencyCache[this.equipment][column][tagIndex] === 'undefined') {
                    this.codeDependencyCache[this.equipment][column][tagIndex] = {}
                }

                this.codeDependencyCache[this.equipment][column][tagIndex] = values;
            },

            fixCachedDependencies(tagIndexWithPaginationOffset, changeType)
            {
                if (typeof this.codeDependencyCache[this.equipment] === 'undefined') {
                    return;
                }

                Object.keys(this.codeDependencyCache[this.equipment]).forEach((column) => {
                    // move each cache one index up (add) / down (remove)
                    // add
                    let columnDependenciesLength = Object.keys(this.codeDependencyCache[this.equipment][column]).length
                    if (changeType === 'add') {

                        for (let workIndex = columnDependenciesLength; workIndex > tagIndexWithPaginationOffset; workIndex--) {
                            this.codeDependencyCache[this.equipment][column][workIndex] = this.codeDependencyCache[this.equipment][column][workIndex - 1];
                        }
                        this.codeDependencyCache[this.equipment][column][tagIndexWithPaginationOffset] = null;

                    } else if (changeType === 'remove') {

                        for (let workIndex = tagIndexWithPaginationOffset; workIndex < columnDependenciesLength; workIndex++) {
                            this.codeDependencyCache[this.equipment][column][workIndex] = this.codeDependencyCache[this.equipment][column][workIndex + 1];
                        }
                        this.codeDependencyCache[this.equipment][column][columnDependenciesLength - 1] = null;

                    }
                });
            },

            collectData()
            {
                // called from outside
                // collect data of all tags
                // and convert it from table into an object again
                let tagDataPerLine = [];
                for (let index in this.tagData) {
                    let rowData = {};
                    for (let column in this.tagData[index]) {
                        if (
                            // column not set or multiselect all values
                            (
                                this.tagData[index][column] === null
                                && !this.isMultiSelectColumn(column)
                            )
                            // not row span or show plus data
                            || column.indexOf('rowSpan') === 0
                            || column.indexOf('showPlus') === 0
                        ) {
                            continue;
                        }

                        // exception for files
                        let columnData = this.tagData[index][column];
                        if (column === 'files') {
                            let files = [];
                            for (let tagIndex in this.tagData[index][column]) {
                                files[tagIndex] = [];
                                for (let fileIndex in this.tagData[index][column][tagIndex]) {
                                    files[tagIndex].push(this.tagData[index][column][tagIndex][fileIndex].id);
                                }
                            }

                            columnData = files;
                        }
                        rowData[column] = columnData;
                    }
                    tagDataPerLine.push(rowData);
                }

                let tagsObject = {};
                let columnKeyShort = {
                    tagId:                 'id',
                    name:                  'n',
                    nameDe:                'nde',
                    nameRu:                'nru',
                    internal:              'i',
                    decisionRequired:      'r',
                    priceRelevant:         'v',
                    active:                'a',
                    tagType:               't',
                    tagDisplay:            'd',
                    files:                 'f',
                    dependencies:          'p',
                    inspectionCriteria:    'e',
                    shippingLine:          's',
                    leasingCompany:        'l',
                    carcassManufacturer:   'c',
                    machineryManufacturer: 'm',
                    modelNumberRange:      'o',
                };

                let validationErrors = [];
                let addValidationError = function (index, column, message) {
                    validationErrors.push({
                        index:   index,
                        column:  column,
                        message: message
                    });
                };

                // compress tag data for each line into an object with dependency data as tree structure,
                // like the user sees it in the view
                let tagTypeKeys = this.tagTypesArray.map(item => item.id);
                for (let index in tagDataPerLine) {
                    let tagLineData = tagDataPerLine[index];

                    // collect non dependency tag data
                    if (typeof tagsObject[tagLineData.tagId] === 'undefined') {
                        tagsObject[tagLineData.tagId] = {p: {}};
                        let requiredFields = ['tagId', 'name', 'tagType', 'tagDisplay', 'files'];
                        requiredFields.forEach((column) => {
                            tagsObject[tagLineData.tagId][columnKeyShort[column]] = tagLineData[column];
                        });

                        // add optional data
                        let optionalDataOnEmpty = ['nameDe', 'nameRu'];
                        optionalDataOnEmpty.forEach((column) => {
                            if (tagLineData[column]) {
                                tagsObject[tagLineData.tagId][columnKeyShort[column]] = tagLineData[column];
                            }
                        });

                        // collect boolean columns
                        // skip false, because the default value is false
                        this.booleanColumns.forEach((column) => {
                            if (tagLineData[column]) {
                                tagsObject[tagLineData.tagId][columnKeyShort[column]] = '1';
                            }
                        });

                        // validate name, tag type and tag display
                        if ((tagLineData.name || '').trim() === '') {
                            addValidationError(index, 'name', i18n.t('Tag Name must not be empty.'));
                        }
                        if (!tagTypeKeys.includes(tagLineData.tagType)) {
                            addValidationError(index, 'tagType', i18n.t('Tag Type has to be selected.'));
                        }
                        if (!tagTypeKeys.includes(tagLineData.tagDisplay)) {
                            addValidationError(index, 'tagDisplay', i18n.t('Tag Display has to be selected.'));
                        }
                    }

                    let dependencyId = tagLineData.id;
                    // create leaf data
                    let leafData = {id: dependencyId};
                    [
                        'inspectionCriteria',
                        'shippingLine',
                        'leasingCompany',
                        'carcassManufacturer',
                        'machineryManufacturer',
                        'modelNumberRange'
                    ].forEach((leafDataElement) => {
                        if (tagLineData[leafDataElement]) {
                            leafData[columnKeyShort[leafDataElement]] = tagLineData[leafDataElement];
                        }
                    });

                    // recursive function to build the dependency tree
                    // adds branches for each column(index) from first given one (serviceType) to repair code
                    // adds the final data to the leaves (after repair code)
                    let buildDependencies = (dependencyData, tagData, columnIndex, leafData) => {
                        let columnId    = this.columnOrder[columnIndex];
                        let columnValue = tagData[columnId] === null ? '- all -' : (tagData[columnId] || '');

                        // check if ISO code is selected
                        if (columnValue === '') {
                            let message = '';
                            if (columnId === 'serviceType') {
                                message = 'Service Type has to be selected.';
                            } else if (columnId === 'isoCode') {
                                message = 'ISO Code has to be selected.';
                            } else if (
                                ['componentCode', 'damageCode', 'repairCode'].includes(columnId)
                                && (
                                    tagsObject[tagLineData.tagId].t === columnId.replace('Code', '')
                                    || tagsObject[tagLineData.tagId].d === columnId.replace('Code', '')
                                )
                            ) {
                                message = 'Please set the codes for tag type and tag display.'
                            }

                            if (message) {
                                addValidationError(index, columnId, i18n.t(message));
                            }
                        }

                        if (typeof dependencyData[columnValue] === 'undefined') {
                            // if current branch has no codes yet
                            // add new empty branch
                            dependencyData[columnValue] = {};
                        }

                        // repair code is the last branch of the tree
                        // if it is reached, stop here and add final data
                        if (columnId === 'repairCode') {
                            // add final data
                            dependencyData[columnValue] = leafData;
                        } else {
                            // if repair code not reached yet
                            // recurse deeper into dependency structure
                            buildDependencies(dependencyData[columnValue], tagData, ++columnIndex, leafData);
                        }
                    };

                    buildDependencies(
                        tagsObject[tagLineData.tagId].p,
                        tagLineData,
                        this.columnOrder.indexOf('serviceType'),
                        leafData
                    );
                }

                this.failedValidation = {};
                if (validationErrors.length > 0) {
                    let messages = [];
                    for (let index in validationErrors) {
                        this.failedValidation[validationErrors[index].index + '_' + validationErrors[index].column] = true;
                        messages.push(i18n.t(validationErrors[index].message));
                    }

                    this.showMessage(messages.join('\n'), 'error', 0, i18n.t('OK'));
                    throw 'Data Collection failed. There are validation errors.';
                } else {
                    return {
                        tagData:       tagsObject,
                        removedTagIds: this.removedTags
                    };
                }
            },

            calculateTagData()
            {
                if (Object.keys(this.tags).length === 0) {
                    this.tagData = [];
                }

                let data = [];

                /*
                * What should it do:
                * iterate through the whole object structure
                * every first line of every column should get a xx_rowSpan = rowSpan
                * every last line of every column should get a xx_showPlus
                * result should be an array of objects with the data of each line
                */

                let levels = [
                    'tagDisplay',
                    'serviceType',
                    'isoCode',
                    'locationCode',
                    'componentCode',
                    'damageCode',
                    'repairCode',
                ];
                let globalIndex = 0;
                let maxLevelRowSpan = levels.indexOf('repairCode');
                let allRowSpans = {
                    tagDisplay:    {},
                    serviceType:   {},
                    isoCode:       {},
                    locationCode:  {},
                    componentCode: {},
                    damageCode:    {},
                };

                // level order: tagDisplay, serviceType, isoCode, componentCode, damageCode, repairCode
                // every row span equals the number of child row spans
                // row span count of the last element in order is always one
                let formatDataRecursive = (levelData, columnIndex, parentLevelData) => {
                    columnIndex     = columnIndex || 0;
                    parentLevelData = parentLevelData || {};

                    if (typeof levelData.id === 'undefined') {
                        let counter = 0;
                        // foreach key in level data
                        Object.keys(levelData).map((key) => {
                            // save current
                            let columnId    = levels[columnIndex];
                            let columnValue = key;
                            if (
                                this.isMultiSelectColumn(columnId)
                                && columnValue === '- all -'
                            ) {
                                columnValue = null;
                            }
                            parentLevelData[columnId] = columnValue;
                            parentLevelData['original_' + columnId] = columnValue;

                            let globalIndexOfFirstOccurrenceOfLevel = globalIndex;
                            let childLevelCounter = formatDataRecursive(levelData[key], columnIndex + 1, parentLevelData);
                            counter += childLevelCounter;
                            if (columnIndex < maxLevelRowSpan) {
                                data[globalIndexOfFirstOccurrenceOfLevel]['rowSpan_' + columnId] = childLevelCounter;
                                allRowSpans[columnId][globalIndexOfFirstOccurrenceOfLevel] = childLevelCounter;
                                // already set row plus for repair codes, due to easier algorithm
                                if (columnId === 'damageCode') {
                                    data[globalIndexOfFirstOccurrenceOfLevel + childLevelCounter - 1]['showPlus_' + levels[columnIndex + 1]] = true;
                                }
                            }
                        });

                        return counter;
                    } else {
                        Object.keys(levelData).map(key => {
                            if (
                                this.isMultiSelectColumn(key)
                                && levelData[key] === '- all -'
                            ) {
                                levelData[key] = null;
                            }
                        });

                        let lineData = {
                            ...parentLevelData,
                            ...levelData
                        };

                        data.push(lineData);
                        globalIndex++;

                        return 1;
                    }
                };

                // add dependencies for each tag
                Object.keys(this.tags).forEach((tagId) => {
                    let lineData = {...this.tags[tagId]};
                    lineData.tagId = tagId;
                    this.booleanColumns.forEach((column) => {
                        lineData[column] = lineData[column] === '1';
                    });
                    let tagDependencies = {};
                    tagDependencies[lineData.tagDisplay] = this.dependencies[tagId] || {};

                    formatDataRecursive(tagDependencies, 0, lineData);
                });

                /*
                 * set row plus position for all columns except the last
                 * algorithm
                 * for each existing parent row span use the equal or slightly greater own row index (last one in current group)
                 * use parent row span index + row span size - own row span size as own row plus position
                 */
                for (let columnIndex = this.columnOrder.indexOf('componentCode'); columnIndex >= 0; columnIndex--) {
                    let columnName = this.columnOrder[columnIndex];
                    for (let rowSpanIndex in allRowSpans[columnName]) {
                        rowSpanIndex = parseInt(rowSpanIndex);
                        let rowSpanSize = allRowSpans[columnName][rowSpanIndex];
                        let childColumnName = this.columnOrder[columnIndex + 1];
                        for (let childRowSpanIndex = rowSpanIndex + rowSpanSize - 1; childRowSpanIndex >= rowSpanIndex; childRowSpanIndex--) {
                            if (!allRowSpans[childColumnName][childRowSpanIndex]) {
                                continue;
                            }
                            let childRowSpanSize = allRowSpans[childColumnName][childRowSpanIndex];
                            let rowPlusPosition = rowSpanIndex + rowSpanSize - childRowSpanSize;
                            data[rowPlusPosition]['showPlus_' + childColumnName] = true;
                            break; // continue 2
                        }
                    }
                }

                /*
                * algorithm
                * for each existing parent row span use the equal or slightly greater own row index (last one in current group)
                * use parent row span index + row span size - own row span size as own row plus position
                */

                for (let columnIndex = this.columnOrder.indexOf('componentCode'); columnIndex >= 0; columnIndex--) {
                    let columnName = this.columnOrder[columnIndex];
                    for (let rowSpanIndex in allRowSpans[columnName]) {
                        rowSpanIndex = parseInt(rowSpanIndex);
                        let rowSpanSize = allRowSpans[columnName][rowSpanIndex];
                        let childColumnName = this.columnOrder[columnIndex + 1];
                        for (let childRowSpanIndex = rowSpanIndex + rowSpanSize - 1; childRowSpanIndex >= rowSpanIndex; childRowSpanIndex--) {
                            if (!allRowSpans[childColumnName][childRowSpanIndex]) {
                                continue;
                            }
                            let childRowSpanSize = allRowSpans[childColumnName][childRowSpanIndex];
                            let rowPlusPosition = rowSpanIndex + rowSpanSize - childRowSpanSize;
                            data[rowPlusPosition]['showPlus_' + childColumnName] = true;
                            break; // continue 2
                        }
                    }
                }

                this.tagData = data;
            },

            async removeFile(tagId, fileId)
            {

                if (!this.allowed.write) {
                    return;
                }

                const res = await this.$dialog.confirm({
                    text: i18n.t('Do you really want to remove this tag file?'),
                    title: i18n.t('Delete File'),
                    persistent: true,
                    actions: {
                        false: i18n.t('No'),
                        true:  i18n.t('Yes'),
                    },
                });

                if (!res) {
                    return;
                }

                // cast non array to array for easier handling
                if (typeof tagId === 'number' || typeof tagId === 'string') {
                    tagId = [tagId]
                }
                // for each tag id
                for (let tagIdIndex in tagId) {
                    // get indexes of rows where to remove files
                    let removeIndexes = this._getTagDataIndexFromId(tagId[tagIdIndex]);
                    // for each remove row index
                    for (let i in removeIndexes) {
                        let removeIndex = removeIndexes[i];
                        // get real index of tag files from files array
                        let realTagIdIndex = this.tagData[removeIndex].tagId.indexOf(tagId[tagIdIndex]);
                        // iterate trough each file to find the one to remove
                        for (let fileIndex in this.tagData[removeIndex].files[realTagIdIndex]) {
                            if (this.tagData[removeIndex].files[realTagIdIndex][fileIndex].id === fileId) {
                                // real remove file (with splice for reactivity)
                                this.tagData[removeIndex].files[realTagIdIndex].splice(fileIndex, 1);
                                break; // proceed with next row or tag
                            }
                        }
                    }
                }

                this.setChanged();
            },

            addFile(tagId, files)
            {
                if (!this.allowed.write) {
                    return;
                }

                // cast non array to array for easier handling
                if (typeof tagId === 'number' || typeof tagId === 'string') {
                    tagId = [tagId]
                }
                // for each tag id
                for (let tagIdIndex in tagId) {
                    // get indexes of rows where to remove files
                    let addIndexes = this._getTagDataIndexFromId(tagId[tagIdIndex]);
                    let addIndex = addIndexes[0];
                    // get real index of tag files from files array
                    let realTagIdIndex = this.tagData[addIndex].tagId.indexOf(tagId[tagIdIndex]);
                    // add files
                    for (let fileIndex in files) {
                        this.tagData[addIndex].files[realTagIdIndex].push(files[fileIndex]);
                    }
                }

                this.showMessage(i18n.t('File upload successful'), 'success', popupShowTime);

                this.setChanged();
            },

            showMessage(content, type, close, buttonText)
            {
                this.$emit('showMessage', content, type, close, buttonText);
            },

            _getTagDataIndexFromId(tagId)
            {
                let indexes = [];
                for (let index in this.tagData) {
                    if (
                        this.tagData[index].tagId.indexOf(tagId) >= 0
                        && this.tagData[index].rowSpan_tagDisplay
                    ) {
                        indexes.push(index);
                    }
                }
                return indexes;
            },

            changeData(tagIndex, column, value)
            {
                if (!this.allowed.write) {
                    return;
                }

                tagIndex += this.paginationOffset;
                let rowSpanData = this.getRowSpanData(tagIndex, 'tagDisplay' );
                for (let i = rowSpanData.index; i < rowSpanData.index + rowSpanData.rowSpan; i++) {

                    let tagData = this.tagData[i];
                    tagData[column] = value;

                    // forbid CEDEX codes which are not selectable by tag type or display
                    // only allow codes which are selected or left from selected code type or display

                    // reset forbidden code values and deactivate fields (last one has to be made in template part)
                    if (
                        column === 'tagType'
                        || column === 'tagDisplay'
                    ) {
                        // handle repair code
                        if (
                            tagData.tagType !== 'repair'
                            && tagData.tagDisplay !== 'repair'
                        ) {
                            tagData.repairCode = '';
                        }

                        // handle damage code
                        if (
                            tagData.tagType === 'component'
                            && tagData.tagDisplay === 'component'
                        ) {
                            tagData.damageCode = '';
                        }

                        // handle tag type
                        if (
                            (
                                tagData.tagType === 'damage'
                                && tagData.tagDisplay === 'component'
                            ) || (
                                tagData.tagType === 'repair'
                                && tagData.tagDisplay !== 'repair'
                            )
                        ) {
                            tagData.tagDisplay = tagData.tagType;
                        }
                    }

                    Vue.set(this.tagData, i, tagData);

                }

                this.setChanged();
            },

            setChanged(state = true)
            {
                if (!this.allowed.write) {
                    return;
                }
                window.showBeforeUnload = state;
            },

            selectCell(tagIndex, column)
            {
                this.selectedRow    = tagIndex;
                this.selectedColumn = column;
            },

            _getSelectableValues(tagIndex, column)
            {
                let log = false;
                if (!this.selectableDependencies) {
                    return [];
                }
                tagIndex += this.paginationOffset;

                let lineData = this.tagData[tagIndex];
                lineData.equipment = this.equipment;
                if (log) console.log((new Date()).toISOString(), '_getSelectableValues: index, column, lineData', tagIndex, column, lineData);

                let selectableValues = [];
                let keyUnionMap = ['locationCode_by_isoCode'];

                Object.keys(this.selectableDependencies).forEach((key) => {

                    // key like serviceType_by_carcass
                    if (key.indexOf(column) !== 0) {
                        return false;
                    }
                    let unionAllColumnValues = keyUnionMap.includes(key);

                    let by = key.split('_by_')[1];
                    let lineValueBy = lineData[by];

                    let valuesWithoutAssignment = [];
                    if (typeof this.selectableDependencies[key]['#'] === 'string') {
                        valuesWithoutAssignment = this.selectableDependencies[key]['#'].split(',')
                    }

                    if (log) console.log('by, value, dependencies', by, lineValueBy, this.selectableDependencies[key]);
                    let checkValues = [];
                    if (this.isMultiSelectColumn(by)) {
                        if (lineValueBy === null) {
                            // all values
                            if (by === 'locationCode') {
                                // skip for none selected value
                                // https://survey-compass.atlassian.net/browse/CORE-2304
                                checkValues = [];
                            } else {
                                checkValues = Object.keys(this.selectableDependencies[key]);
                            }
                            if (log) console.log('check values', checkValues);
                        } else {
                            // split value string on ','
                            checkValues = lineValueBy.split(',');
                            if (log) console.log('check values', checkValues);
                        }
                    } else if (
                        lineValueBy // value selected - not empty
                    ) {
                        checkValues.push(lineValueBy);
                    } else {
                        if (log) console.log('not found - skip: by, lineValueBy', by, lineValueBy)
                    }

                    let keyValues = [];
                    checkValues.forEach((byValue) => {
                        if (typeof this.selectableDependencies[key][byValue] === 'string') {
                            let selectableValue = this.selectableDependencies[key][byValue].split(',')
                            selectableValue = selectableValue.concat(valuesWithoutAssignment);

                            if (unionAllColumnValues) {
                                keyValues.push(selectableValue);
                                if (log) console.log('added key value, by value, without assignment', selectableValue, byValue, valuesWithoutAssignment)
                            } else {
                                selectableValues.push(selectableValue);
                                if (log) console.log('added selectable value, by value, without assignment', selectableValue, byValue, valuesWithoutAssignment)
                            }

                        } else {
                            if (log) console.log('skipped byValue - not found', byValue);
                        }
                    });

                    if (unionAllColumnValues) {
                        // union all values
                        let result = {};
                        keyValues.forEach(values => {
                            values.forEach(value => {
                                result[value] = true;
                            });
                        });
                        // unique
                        selectableValues.push(Object.keys(result));
                    }
                });

                // intersect data
                if (log) console.log('intersect values', selectableValues);
                let result = this._intersectDataArrays(selectableValues);
                if (log) console.log('intersected data', tagIndex, column, result);

                return result;
            },

            updateDependencies(tagIndex, column)
            {
                if (!column) {
                    return false;
                }

                let vueComponent = this.getComponent(tagIndex, column);
                if (
                    vueComponent !== null
                    && typeof vueComponent !== 'undefined'
                ) {
                    vueComponent.setLoading(true);
                    let selectableValues = this._getSelectableValues(tagIndex, column);
                    vueComponent.updateSelectableEntries(selectableValues);

                    vueComponent.setLoading(false);
                }
            },

            _intersectDataArrays(data)
            {
                // intersect data between given values
                let result = [];
                let firstStep = true;
                data.forEach(values => {
                    if (firstStep) {
                        result = values;
                        firstStep = false;
                    } else {
                        try {
                            result = result.filter(value => values.includes(value));
                        } catch (e) {
                            console.log('result is not an array', values)
                            console.log(e);
                        }
                    }
                });

                return result;
            },

            getAvailableTagTypes(tagIndex)
            {
                tagIndex += this.paginationOffset;
                let tagData = this.tagData[tagIndex];
                let tagDisplays = Object.assign({}, this.tagTypes);
                if (tagData.tagType !== 'component') {
                    delete tagDisplays.component;
                    if (tagData.tagType !== 'damage') {
                        delete tagDisplays.damage;
                    }
                }

                let array = [];
                Object.keys(tagDisplays).forEach((key) => {
                    array.push({id: key, name: tagDisplays[key]});
                });
                return array;
            },

            parseCodeDependencyData(tagIndex, column)
            {
                let cachedValue = this.getCodeDependencies(tagIndex, column);
                if (cachedValue) {
                    return cachedValue;
                }

                let log = false;
                let selectableValues = this._getSelectableValues(tagIndex, column);

                if (log) console.log('parseCodeDependencyData: index, column, selectable values', tagIndex, column, selectableValues);
                let allArrayIdentifierMap = {
                    serviceType:        'serviceTypesArray',
                    isoCode:            'isoCodesArray',
                    locationCode:       'locationCodesArray',
                    componentCode:      'componentCodesArray',
                    damageCode:         'damageCodesArray',
                    repairCode:         'repairCodesArray',
                    inspectionCriteria: 'inspectionCriteriasArray',
                };

                // get all values from field
                // remove all non selectable values
                let allArray = this[allArrayIdentifierMap[column]];
                let allValues = [];
                if (selectableValues.length > 0) {
                    allArray.forEach((data) => {
                        if (selectableValues.includes(data.id)) {
                            allValues.push(data);
                        }
                    });
                }

                // check if selected value(s) still exist in selectable values (multiselect makes it trickier)
                // split values and check each one individually
                // remove it if necessary and rejoin the values
                let values = this.tagData[tagIndex + this.paginationOffset][column];
                if (values !== null) {
                    let vueComponent = this.getComponent(tagIndex, column);
                    if (
                        vueComponent !== null
                        && typeof vueComponent !== 'undefined'
                    ) {
                        vueComponent.updateSelectableEntries(selectableValues);
                    }
                }

                this.setCodeDependencies(tagIndex, column, allValues);

                return allValues;
            },

            groupCodes(column, values)
            {
                if (
                    this.groupCodesCache[column]
                    && this.groupCodesCache[column][values]
                ) {
                    return this.groupCodesCache[column][values];
                }
                // convert isoCodes to array with objects{id, name}
                let groupMaps = {
                    isoCode:      this.isoCodeToSurveyTypeName,
                    locationCode: this.locationCodePrefixToViewTypeName,
                };
                let groupMap = groupMaps[column] || {};

                let sortedByMapEntity = {};
                // sort iso codes by survey type
                for (let index in values) {
                    let value = values[index].id;
                    if (column === 'locationCode') {
                        value = value.substring(0, 1);
                    }
                    let header = groupMap[value];
                    if (typeof sortedByMapEntity[header] === 'undefined') {
                        sortedByMapEntity[header] = [];
                    }
                    sortedByMapEntity[header].push(values[index]);
                }
                // create final array with survey types as group header and divider
                let finalItems = [];
                for (let headerName in sortedByMapEntity) {
                    if (finalItems.length > 0) {
                        finalItems.push({divider: true});
                    }
                    finalItems.push({
                        // name: '-- ' + i18n.t('All') + ' ' + headerName + ' --',
                        // id:   'selectAll_' + headerName,
                        header: headerName
                    });

                    finalItems.splice(finalItems.length, 0, ...sortedByMapEntity[headerName]);
                }

                if (typeof this.groupCodesCache[column] === 'undefined') {
                    this.groupCodesCache[column] = {};
                }
                this.groupCodesCache[column][values] = finalItems;

                return finalItems;
            },
        },
        computed: {
            activeTagCount() {
                let activeCount = 0;
                for (let index in this.tagData) {
                    if (
                        this.showInactive
                        || this.tagData[index].active
                    ) {
                        activeCount++;
                    }
                }
                return activeCount;
            },
            visibleColumns() {
                let visibleColumns = [];
                for (let columnIndex in this.columns) {
                    visibleColumns[this.columns[columnIndex].id] = this.columns[columnIndex].visible;
                }
                return visibleColumns;
            },
            columnOrder() {
                let columnOrder = [];
                // tagName - modelNumberRange
                for (let columnIndex in this.columns) {
                    columnOrder.push(this.columns[columnIndex].id);
                    if (this.columns[columnIndex].id === 'modelNumberRange') {
                        break;
                    }
                }
                return columnOrder;
            },
            pageCount() {
                return Math.ceil(this.tagData.length / this.pageSize);
            },
            paginationOffset() {
                return (this.currentPage - 1) * this.pageSize;
            },
            paginatedTagData() {
                if (this.tagData.length === 0) {
                    return [];
                }

                let start = (this.currentPage - 1) * this.pageSize;
                let end = Math.min(this.currentPage * this.pageSize, this.tagData.length);
                let firstLine = Object.assign({}, this.tagData[start]);

                // correct row span for first line data, if page is greater than 1
                if (this.currentPage > 1) {
                    //start from damage code column and go to the left (damage code ist the last one with row span)
                    for (let columnIndex = this.columnOrder.indexOf('damageCode'); columnIndex >= this.columnOrder.indexOf('tagDisplay'); columnIndex--) {
                        let columnName = this.columnOrder[columnIndex];
                        // if row span of this column is not already set
                        if (!firstLine['rowSpan_' + columnName]) {
                            let rowSpanData = this.getRowSpanData(start, columnName);
                            firstLine['rowSpan_' + columnName] = rowSpanData.rowSpan - (start - rowSpanData.index);
                        }
                    }
                }

                let paginatedData = [firstLine];
                for (let i = start + 1; i < end; i++) {
                    paginatedData.push(Object.assign({}, this.tagData[i]));
                }

                return paginatedData;
            },
            tagTypesArray() {
                return this.convertCodes('tagType', false);
            },
            serviceTypes() {
                let serviceTypes = {};
                for (let index in this.serviceTypesArray) {
                    serviceTypes[this.serviceTypesArray[index].id] = this.serviceTypesArray[index].name;
                }
                return serviceTypes;
            },
            isoCodesArray() {
                // convert isoCodes to array with objects{id, name}
                return this.convertCodes('isoCode', true);
            },
            locationCodesArray() {
                return this.convertCodes('locationCode', true);
            },
            componentCodesArray() {
                return this.convertCodes('componentCode', true);
            },
            damageCodesArray() {
                return this.convertCodes('damageCode', true);
            },
            repairCodesArray() {
                return this.convertCodes('repairCode', true);
            },
            inspectionCriteriasArray() {
                return this.convertCodes('inspectionCriteria');
            },
            leasingCompanysArray() {
                return this.convertCodes('leasingCompany', false);
            },
            shippingLinesArray() {
                return this.convertCodes('shippingLine', false);
            },
            carcassManufacturersArray() {
                return this.convertCodes('carcassManufacturer', false);
            },
            machineryManufacturersArray() {
                return this.convertCodes('machineryManufacturer', false);
            },
            multiSelectColumns() {
                let data = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].multiselect) {
                        data.push(this.columns[columnIndex].id);
                    }
                }
                return data;
            },
            booleanColumns() {
                let data = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].boolean) {
                        data.push(this.columns[columnIndex].id);
                    }
                }
                return data;
            },
            filters() {
                let filters = [];

                this.columns.forEach(column => {
                    if (!column.filter) {
                        // column has no filter
                        return true;
                    }

                    let filter = {
                        name:  column.id,
                        title: column.title,
                        data:  []
                    };
                    if (this.filterTypes.string.includes(column.id)) {
                        filter.type = 'string';
                    } else if (this.filterTypes.boolean.includes(column.id)) {
                        filter.type = 'boolean';
                        filter.data = [
                            {id: 0, name: i18n.t('unset')},
                            {id: 1, name: i18n.t('active')},
                            {id: 2, name: i18n.t('inactive')},
                        ];
                    } else if (this.filterTypes.data.includes(column.id)) {
                        filter.type = 'data';
                        if (column.id === 'tagDisplay') {
                            filter.data = this.tagTypesArray;
                        } else {
                            filter.data = this[column.id + 'sArray'] || [];
                        }
                    }

                    filters.push(filter);
                });

                return filters;
            }
        }
    }
</script>

<style scoped>

    div.editor-box table.vcs-table tr.active td.actions img.delete.disabled {
        cursor: default;
        opacity: 0.4;
    }

    div.editor-box table.vcs-table tr td.dependency-warning {
        background-color: rgba(255,255,0,0.5) !important;
    }

    div.editor-box table.vcs-table tr.selected td {
        background-color: var(--selected-cell-background);
    }
    div.editor-box table.vcs-table td.validation-failed {
         background-color: rgba(255,0,0,0.3) !important;
    }
    div.editor-box table.vcs-table td:not(.contentParameter) {
        user-select: text;
        -moz-user-select: text;
        -webkit-user-select: text;
        -ms-user-select: text;
    }
    div.editor-box table.vcs-table td.isoCode,
    div.editor-box table.vcs-table td.locationCode {
        white-space: pre-line;
    }
    div.editor-box table.vcs-table td img.small {
        width: 16px;
        height: 16px;
        margin: 0 auto;
        display: block;
        cursor: pointer;
    }
</style>
<style>
    div.editor-table.tags {
        background-image: url('../../assets/background_tags.svg');
    }

    /* table cell v-input (Text) */

    td div.v-input.v-text-field {
        padding: 0;
        margin: 0 0 8px;
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot {
        margin: 0;
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot:after {
        border: none
    }
    td div.v-input.v-text-field div.v-input__control div.v-input__slot div.v-text-field__slot input {
        padding: 0;
        background-color: var(--main-menu-background);
        font-size: 12px;
    }
    td div.v-input.v-text-field div.v-input__control div.v-text-field__details {
        display: none;
    }

    /* table cell v-input (Check Box) */

    td div.v-input.v-input--checkbox {
        margin: 0 0 8px;
        padding: 2px;
    }
    td div.v-input.v-input--checkbox div.v-input__control div.v-input__slot {
        margin: 0;
    }
    td div.v-input.v-input--checkbox div.v-input__control div.v-input__slot div.v-input--selection-controls__input {
        margin: 0;
        height: 16px;
        width: 16px;
    }
    td div.v-input.v-input--checkbox div.v-input__control div.v-input__slot div.v-input--selection-controls__input div.v-input--selection-controls__ripple {
        display: none;
    }
    td div.v-input.v-input--checkbox div.v-input__control div.v-messages {
        display: none;
    }

    /* table cell Files */
    td div.file-count {
        margin-top: 2px;
        margin-bottom: 6px;
    }

    /* table cell v-input (Select) */

    td div.v-input.v-select {
        font-size: 12px;
        padding: 0;
        margin: 0 0 8px;
    }
    td div.v-input.v-select div.v-input__slot {
        margin: 0;
    }
    td div.v-input.v-select div.v-input__slot div.v-select__slot > div.v-select__selections > div.v-select__selection {
        margin: 0;
    }
    td div.v-input.v-select div.v-input__slot div.v-select__slot > div.v-select__selections > input {
        padding: 0;
    }
    td div.v-input.v-select div.v-input__slot div.v-select__slot > div.v-input__append-inner {
        margin: 0;
    }
    td div.v-input.v-select div.v-input__slot div.v-select__slot > div.v-input__append-inner > div.v-input__icon {
        height: 20px;
    }
    td div.v-input.v-select > div.v-input__control > div.v-input__slot > div.v-select__slot > div.v-select__selections > div.v-select__selection {
        max-width: 100%;
    }
    td div.v-input.v-select > div.v-input__control > div.v-input__slot > div.v-select__slot > div.v-input__append-inner {
        padding: 0;
    }
    td div.v-input.v-select > div.v-input__control > div.v-input__slot > div.v-select__slot > div.v-input__append-inner > div.v-input__icon > i.v-icon {
        width: 16px;
    }
</style>